import { ComplexEnumItem } from '../../../utils/complexEnum/ComplexEnumItem'

export class CustomFieldClassTypeItem<
  ID extends Lowercase<string>,
  ClassType extends string
> extends ComplexEnumItem<ID> {
  /**
   * the name of the class in the schema
   */
  readonly classType: ClassType
  /**
   * the human readable name of the class
   */
  readonly type: string
  constructor({
    id,
    type,
    classType,
  }: Pick<
    CustomFieldClassTypeItem<ID, ClassType>,
    'id' | 'type' | 'classType'
  >) {
    super(id)
    this.classType = classType
    this.type = type
  }
}
